import axios from "axios";
import { appEnv } from "../appEnv";
import {
  setLanguageInterceptor,
  setTokenRequestInterceptor,
} from "./interceptors";

const api = axios.create({
  baseURL: appEnv.REACT_APP_API_URL,
  transitional: {
    clarifyTimeoutError: true,
  },
  params: {
    tupi_cache_purge: Date.now(),
  },
});

api.interceptors.request.use(setTokenRequestInterceptor);
api.interceptors.request.use(setLanguageInterceptor);

export default api;
